export enum EntityTypes {
    Unknown = 0,

    Hub = 1,

    Organization = 2,

    User = 3,

    Challenge = 4,

    BlogItem = 5,

    Concept = 6,

    SentMessage = 7,

    ChallengeGroup = 8,

    Page = 9,

    Block = 10,

    Match = 11,

    HubUpdate = 12,

    OrganizationUpdate = 13,

    ChallengeUpdate = 14,

    ChallengeGroupUpdate = 15,
    
    Update = 16,

    Site = 17,

    Platform = 18,

    RepeatingSetting = 19,

    Newsletter = 20,
}